export default "__VITE_ASSET__665aefa0__"